/**
 * How completed jobs (status 8) draw their trip line on the Route View map.
 *
 * DIRECTIONS — Mapbox driving directions between job start/end (snapped to roads).
 * ACTUAL     — GPS trace from API `route_locations.layers` (activeJob); may sit off the road.
 */
export const RouteViewCompletedRouteSource = {
  DIRECTIONS: 'directions',
  ACTUAL: 'actual',
};

/** @type {typeof RouteViewCompletedRouteSource[keyof typeof RouteViewCompletedRouteSource]} */
export const ROUTE_VIEW_COMPLETED_ROUTE_SOURCE = RouteViewCompletedRouteSource.DIRECTIONS;

export const routeViewUsesActualCompletedRoute = () =>
  ROUTE_VIEW_COMPLETED_ROUTE_SOURCE === RouteViewCompletedRouteSource.ACTUAL;
